import { Button, Form, Row, Space, Col } from "antd";
import React from "react";
import { FilterProps } from "./interface";
import Rederer from "./renderer";

const Filter: React.FC<FilterProps> = ({ onComplete, items, onReset }) => {
  const [form] = Form.useForm();
  const fields = React.useMemo(() => {
    return items.map((item, index) => (
      <Col span={item.col} key={index}>
        <Rederer {...item} onSubmit={form.submit} />
      </Col>
    ));
  }, [items, form]);

  return (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      form={form}
      onFinish={onComplete}
      layout="horizontal"
    >
      <Row gutter={12}>
        {fields}
        <Col span={items[items.length - 1].col} key={'btls'}>
          <Form.Item wrapperCol={{ offset: 3, span: 18 }}>
            <Space>
              <Button htmlType="submit" type="primary">
                搜索
              </Button>
              <Button htmlType="reset" type="default" onClick={onReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>

    </Form>
  );
};

export default Filter;
